import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 28, ...props }) => {
  const reduceMotion = useReducedMotion();
  return <motion.div className={className} initial={reduceMotion ? false : { opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={reduceMotion ? { duration: 0 } : { duration: 0.65, delay, ease: EASE }} {...props}>{children}</motion.div>;
};

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1" }) => {
  const reduceMotion = useReducedMotion();
  const MotionTag = motion[Tag] || motion.h1;
  return (
    <MotionTag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduceMotion ? false : { y: "115%" }}
            animate={{ y: 0 }}
            transition={reduceMotion ? { duration: 0 } : { duration: 0.8, delay: delay + i * 0.1, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
};

export const Rule = ({ className = "" }) => {
  const reduceMotion = useReducedMotion();
  return <motion.div className={`h-px bg-rule origin-left ${className}`} initial={reduceMotion ? false : { scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }} transition={reduceMotion ? { duration: 0 } : { duration: 0.75, ease: EASE }} />;
};

export const Chapter = ({ children, className = "" }) => (
  <div className={className}>
    <span className="font-sans text-[13px] md:text-[14px] font-semibold uppercase tracking-[0.16em] leading-[1.2] text-terra">{children}</span>
  </div>
);
